/**
 * This returns the display name of the plan.
 * @param plan
 * @returns {`${string} plan`}
 */
export default plan => `${plan} plan`
